import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { CompanyService } from 'src/app/setting/services/company.service';
import { ParentOfComponent } from '../../../../ui/parent-component/components/parent-of.component';

@Component({
    selector: 'app-night-shift-duration-setting',
    templateUrl: './night-shift-duration-setting.component.html',
    styleUrls: ['./night-shift-duration-setting.component.css']
})
export class NightShiftDurationSettingComponent extends ParentOfComponent implements OnInit {
    @Input() public settings: any;

    public form: UntypedFormGroup;

    public constructor(
        private _companyService: CompanyService,
    ) {
        super();
    }

    public get f(): { [formControlName: string]: AbstractControl; } {
        return this.form.controls;
    }

    public ngOnInit(): void {
        this.form = this.fb.group({
            'company.attendance.use_night_shift_duration': [false],
            'company.attendance.night_hours_from': ['22:00'],
            'company.attendance.night_hours_to': ['06:00'],
        });

        this.form.patchValue({
            'company.attendance.use_night_shift_duration': this.settings.company_settings.attendance?.night_hours_from !== '22:00' || this.settings.company_settings.attendance?.night_hours_to !== '06:00',
            'company.attendance.night_hours_from': this.settings.company_settings.attendance?.night_hours_from,
            'company.attendance.night_hours_to': this.settings.company_settings.attendance?.night_hours_to,
        });
    }

    public onSubmit(): void {
        const value = this.form.value;

        value.settings_type = 'attendance';

        if (value['company.attendance.use_night_shift_duration'] === false) {
            value['company.attendance.night_hours_from'] = '22:00';
            value['company.attendance.night_hours_to'] = '06:00';
        }

        void this._companyService.saveCompanySetting(this.form.value);
    }
}
